const common = {
  namespaced: true,
  state: {
    userInfo: {},
    menuIDs: [],
    clickTime:null
  },
  mutations: {
    getUserInfo(state, users) {
      state.userInfo = users
    },
    getMenuIDs(state, ids) {
      state.menuIDs = ids
    },
    getClickTime(state, ids) {
      state.clickTime = ids
    },
  },
}
export default common
